export const TESTING_URLS = {
    url: 'https://localhost:5000/'
}

export const DEPLOYMENT_URLS = {
    url: 'https://schedulion.herokuapp.com/'
}